import { useMatchScreenWidth } from '@keplerco/core';
import React, { PropsWithChildren } from 'react';
import { PeerAssessmentAssigneeResponse, PeerAssessmentReviewerResponse } from '../../overmind/actions';

export function AssessmentAssigneeListItemLayout({ assignee, children }: PropsWithChildren<{ assignee: PeerAssessmentAssigneeResponse }>): React.ReactElement {
  const isMobile = useMatchScreenWidth('mobile');

  return (
    <React.Fragment>
      <div>
        <h5>{assignee.fullName}</h5>
        <div style={{ color: 'var(--text_1)' }}>
          {assignee.department ?? 'No department'} | {assignee.team ?? 'No team'}
        </div>
      </div>

      {!isMobile && (
        <div>
          {!!assignee.roles && <h5>{assignee.roles.map(role => role.name).join(', ')}</h5>}
          <div style={{ color: 'var(--text_1)' }}>{assignee.email}</div>
        </div>
      )}

      {!!children && <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 4 }}>{children}</div>}
    </React.Fragment>
  );
}

export function AssessmentReviewerListItemLayout({ reviewer, children }: PropsWithChildren<{ reviewer: PeerAssessmentReviewerResponse }>): React.ReactElement {
  const isMobile = useMatchScreenWidth('mobile');

  return (
    <React.Fragment>
      <h5>{reviewer.fullName}</h5>

      {!isMobile && !!reviewer.roles && (
        <div>
          <h5>{reviewer.roles.map(role => role.name).join(', ')}</h5>
        </div>
      )}

      {!!children && <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 12 }}>{children}</div>}
    </React.Fragment>
  );
}
